import { DomHandler } from 'primevue/utils';
/* TODO remove when primevue will be updated to ^3.34 https://github.com/primefaces/primevue/blob/3.34.0/components/lib/tooltip/Tooltip.js */
export default {
  /*
  * use el.$instance.getTooltipElement instead
  */
  getTooltipElement: function getTooltipElement(el) {
    return document.getElementById(el.$_ptooltipId);
  },
  /*
  * use el.$instance.getHostOffset instead
  */
  getHostOffset: function getHostOffset(el) {
    const offset = el.getBoundingClientRect();
    const targetLeft = offset.left + DomHandler.getWindowScrollLeft();
    const targetTop = offset.top + DomHandler.getWindowScrollTop();

    return { left: targetLeft, top: targetTop };
  },
  /*
  * use el.$instance.alignTop instead
  */
  alignTop: function alignTop(el) {
    this.preAlign(el, 'top');
    const tooltipElement = this.getTooltipElement(el);
    const hostOffset = this.getHostOffset(el);
    const left = hostOffset.left + (DomHandler.getOuterWidth(el) - DomHandler.getOuterWidth(tooltipElement)) / 2;
    const top = hostOffset.top - DomHandler.getOuterHeight(tooltipElement);

    tooltipElement.style.left = `${left }px`;
    tooltipElement.style.top = `${top }px`;
  },
  /*
  * use el.$instance.alignBottom instead
  */
  alignBottom: function alignBottom(el) {
    this.preAlign(el, 'bottom');
    const tooltipElement = this.getTooltipElement(el);
    const hostOffset = this.getHostOffset(el);
    const left = hostOffset.left + (DomHandler.getOuterWidth(el) - DomHandler.getOuterWidth(tooltipElement)) / 2;
    const top = hostOffset.top + DomHandler.getOuterHeight(el);

    tooltipElement.style.left = `${left }px`;
    tooltipElement.style.top = `${top }px`;
  },
  /*
  * use el.$instance.preAlign instead
  */
  preAlign: function preAlign(el, position) {
    const tooltipElement = this.getTooltipElement(el);

    tooltipElement.style.left = `${-999 }px`;
    tooltipElement.style.top = `${-999 }px`;
    tooltipElement.className = `p-tooltip p-component p-tooltip-${position} ${el.$_ptooltipClass || ''}`;
  },
  /*
  * use el.$instance.isOutOfBounds instead
  */
  isOutOfBounds: function isOutOfBounds(el) {
    const tooltipElement = this.getTooltipElement(el);
    const offset = tooltipElement.getBoundingClientRect();
    const targetTop = offset.top;
    const targetLeft = offset.left;
    const width = DomHandler.getOuterWidth(tooltipElement);
    const height = DomHandler.getOuterHeight(tooltipElement);
    const viewport = DomHandler.getViewport();

    return targetLeft + width > viewport.width || targetLeft < 0 || targetTop < 0 || targetTop + height > viewport.height;
  },
};
